import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "antd";
const SubscriptionCardSkeleton = ({ isExpanded = false })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: [
            "rc-account-v2-subscription-card",
            "rc-account-v2-subscription-card--active",
            isExpanded ? "rc-account-v2-subscription-card--expanded" : ""
        ].filter(Boolean).join(" "),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-subscription-card__header rc-account-v2-subscription-card__header--skeleton",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "rc-account-v2-subscription-card__header-left",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                "aria-hidden": true,
                                className: "rc-account-v2-subscription-card__avatar-skeleton"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 7
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                active: true,
                                                size: "small",
                                                style: {
                                                    width: 220,
                                                    height: 18
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                active: true,
                                                size: "small",
                                                style: {
                                                    width: 62,
                                                    height: 22
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Skeleton.Input, {
                                        active: true,
                                        size: "small",
                                        style: {
                                            width: 440,
                                            height: 13
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "rc-account-v2-subscription-card__header-right",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton.Button, {
                                active: true,
                                size: "small",
                                style: {
                                    width: 104,
                                    height: 32
                                }
                            }),
                            /*#__PURE__*/ _jsx(Skeleton.Button, {
                                active: true,
                                size: "small",
                                style: {
                                    width: 32,
                                    height: 32
                                }
                            }),
                            /*#__PURE__*/ _jsx(Skeleton.Button, {
                                active: true,
                                size: "small",
                                style: {
                                    width: 24,
                                    height: 24
                                }
                            })
                        ]
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ _jsx("div", {
                className: "rc-account-v2-subscription-card__body",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "rc-account-v2-subscription-card__detail",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "rc-account-v2-license-area",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "rc-account-v2-section-toolbar",
                                children: [
                                    /*#__PURE__*/ _jsx(Skeleton.Input, {
                                        active: true,
                                        size: "small",
                                        style: {
                                            width: 220,
                                            height: 15
                                        }
                                    }),
                                    /*#__PURE__*/ _jsxs("span", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 8
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                active: true,
                                                size: "small",
                                                style: {
                                                    width: 110,
                                                    height: 13
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Skeleton.Button, {
                                                active: true,
                                                size: "small",
                                                style: {
                                                    width: 148,
                                                    height: 32
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("section", {
                                className: "rc-account-v2-section-card",
                                "aria-hidden": true,
                                children: [
                                    /*#__PURE__*/ _jsxs("header", {
                                        className: "rc-account-v2-section-card__head",
                                        children: [
                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                active: true,
                                                size: "small",
                                                style: {
                                                    width: 18,
                                                    height: 18,
                                                    borderRadius: 4
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                active: true,
                                                size: "small",
                                                style: {
                                                    width: 140,
                                                    height: 15
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            marginBottom: 12
                                        },
                                        children: /*#__PURE__*/ _jsx(Skeleton.Input, {
                                            active: true,
                                            block: true,
                                            style: {
                                                height: 13
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "rc-account-v2-section-card__bars",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "rc-account-v2-subscription-card__capacity-row",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                                active: true,
                                                                size: "small",
                                                                style: {
                                                                    width: 130,
                                                                    height: 12
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                                active: true,
                                                                size: "small",
                                                                style: {
                                                                    width: 82,
                                                                    height: 11
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                        active: true,
                                                        block: true,
                                                        style: {
                                                            height: 6
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "rc-account-v2-subscription-card__capacity-row",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                                active: true,
                                                                size: "small",
                                                                style: {
                                                                    width: 145,
                                                                    height: 12
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                                active: true,
                                                                size: "small",
                                                                style: {
                                                                    width: 82,
                                                                    height: 11
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                        active: true,
                                                        block: true,
                                                        style: {
                                                            height: 6
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("section", {
                                className: "rc-account-v2-section-card",
                                "aria-hidden": true,
                                children: [
                                    /*#__PURE__*/ _jsxs("header", {
                                        className: "rc-account-v2-section-card__head",
                                        children: [
                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                active: true,
                                                size: "small",
                                                style: {
                                                    width: 18,
                                                    height: 18,
                                                    borderRadius: 4
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                active: true,
                                                size: "small",
                                                style: {
                                                    width: 100,
                                                    height: 15
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Skeleton.Button, {
                                                active: true,
                                                size: "small",
                                                style: {
                                                    width: 152,
                                                    height: 32,
                                                    marginLeft: "auto"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        style: {
                                            marginBottom: 12,
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                active: true,
                                                block: true,
                                                style: {
                                                    height: 13
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                active: true,
                                                size: "small",
                                                style: {
                                                    width: 340,
                                                    height: 13
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "rc-account-v2-subscription-card__license-row",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "rc-account-v2-subscription-card__license-row-line",
                                            style: {
                                                pointerEvents: "none"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx(Skeleton.Input, {
                                                    active: true,
                                                    size: "small",
                                                    style: {
                                                        width: 310,
                                                        height: 32
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Skeleton.Button, {
                                                    active: true,
                                                    size: "small",
                                                    style: {
                                                        width: 90,
                                                        height: 24
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Skeleton.Button, {
                                                    active: true,
                                                    size: "small",
                                                    style: {
                                                        width: 110,
                                                        height: 24
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    style: {
                                                        marginLeft: "auto",
                                                        display: "flex",
                                                        gap: 6
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                                                            active: true,
                                                            size: "small",
                                                            style: {
                                                                width: 28,
                                                                height: 28
                                                            }
                                                        }),
                                                        /*#__PURE__*/ _jsx(Skeleton.Button, {
                                                            active: true,
                                                            size: "small",
                                                            style: {
                                                                width: 24,
                                                                height: 24
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
export { SubscriptionCardSkeleton };
